import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const CustomToolbar = ({ label, onNavigate, views, view, onView }) => {
  return (
    <div className="custom-toolbar between">
      
      <div className="fecha column gap-5">

        <div className="align-center gap-10">
          <button onClick={() => onNavigate("PREV")} className="desplazar negro no-border"><FaChevronLeft /></button>
          <span className="rbc-toolbar-label mb-5 w-200">{label}</span>
          <button onClick={() => onNavigate("NEXT")} className="desplazar negro no-border"><FaChevronRight /></button>
        </div>

       {/*  <button onClick={() => onNavigate("TODAY")} className="actual">Fecha actual</button> */}
      </div>

      <div className="view-buttons align-center gap-10">
        <p>Ver:</p>
        {views.map((v) => (
          <button
            key={v}
            onClick={() => onView(v)}
            className={view === v ? "rbc-active" : ""}
          >
            {v === "month" && "Mes"}
            {v === "week" && "Semana"}
            {v === "day" && "Día"}
            {v === "agenda" && "Citas"}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomToolbar;
